import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import Vuetify from "vuetify";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ActionGeneralRules } from "../../models/actions.model";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  GENERAL_RULES_CONSTANTS,
  ORDER_FORM_LABELS,
  ORDER_STATUS
} from "../../constants/GeneralRulesConstants";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";

Vue.use(Vuetify);
@Component({
  name: "ChangeOrder",
  components: { DynamicSelect }
})
export default class ChangeMedicalOrder extends Vue {
  @Prop() showChangeMedicalOrderModal!: boolean;
  @Prop() actionToEdit!: ActionGeneralRules;
  @Prop() isToEdit!: boolean;

  orderFieldsValidation = false;
  cardClass = STYLE_CLASSES.CARD;
  CANCEL_LABEL = ORDER_FORM_LABELS.CANCEL;
  SAVE_LABEL = ORDER_FORM_LABELS.SAVE;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  CHANGE_MEDICAL_ORDER_TITLE =
    GENERAL_RULES_CONSTANTS.TITTLES.CHANGE_MEDICAL_ORDER;
  FieldListMedicalOrderModel = [] as DynamicSelectData[];

  FieldSelectConfigMedicalOrder: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: Object.values(ORDER_STATUS).map(item => ({
      id: item.key,
      name: item.name
    })),
    filled: false,
    messageLabel: GENERAL_RULES_CONSTANTS.LABEL.SELECT_ORDER_STATE,
    hideDetails: false,
    rules: [
      FORM_VALIDATORS.REQUIRED_LIST,
      FORM_VALIDATORS.REQUIRED_OBJECT_FILLED
    ],
    attach: false
  };

  mounted() {
    if (this.isToEdit) {
      this.preloadInfo();
    }
  }

  preloadInfo() {
    this.FieldListMedicalOrderModel = [
      {
        id: this.actionToEdit.changeMedicalOrder?.fields?.state?.id as string,
        name: this.actionToEdit.changeMedicalOrder?.fields?.state
          ?.name as string
      }
    ];
  }

  save() {
    this.$emit(
      GENERAL_RULES_CONSTANTS.EMITTERS.SAVE_CHANGE_MEDICAL_ORDER_MODAL,
      {
        name: GENERAL_RULES_CONSTANTS.LABEL.CHANGE_STATE,
        fields: {
          state: this.FieldListMedicalOrderModel[0]
        }
      }
    );
  }

  cancel() {
    this.$emit(
      GENERAL_RULES_CONSTANTS.EMITTERS.CLOSE_CHANGE_MEDICAL_ORDER_MODAL,
      false
    );
  }
}
